module.exports = __webpack_public_path__ + "img/sepa.799d8c87.svg";